<template>
  <div class="pl-6 bradgall">
    <EditComp
      :events="events"
      :isShowContentEdit="isShowContentEdit"
      :parentIndex="parentIndex"
      :Platform="Platform"
      :useMixinTypeA="true"
      @Updatepreview="UpdatePreview"
      @DisableEdit="CancelEdit"
    />

    <h2 class="font-semibold text-xl">Branding Gallery</h2>
    <div class="mt-8">
      <el-tabs
        v-model="activeName"
        @tab-click="handleTabClick"
        class="istabpane-cs"
        type="border-card"
      >
        <el-tab-pane name="Instagram">
          <div
            slot="label"
            class="text-center flex items-center cursor-pointer"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/branding/instagram.png"
              alt="image"
              class="w-6 h-6"
            />

            <p class="text-center text-4f4f4f pl-2">Instagram</p>
          </div>
          <InstagramEvents
            @isShowUpdate="ShowEdit"
            @Platformname="Platformname"
            :layout="layoutPriview"
            :events="eventsCard"
            :PreviewUpdate="PreviewUpdateInstagram"
            :svg="InstagramTemplate"
            :Posts="PostsInsta"
          />
        </el-tab-pane>

        <el-tab-pane name="LinkedIn"
          ><div
            slot="label"
            class="flex items-center text-center cursor-pointer"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/branding/linkedin.png"
              alt="image"
              class="w-6 h-6"
            />

            <p class="text-center text-4f4f4f pl-2">LinkedIn</p>
          </div>
          <LinkedInEvents
            @isShowUpdate="ShowEdit"
            @Platformname="Platformname"
            :layout="layoutPriview"
            :events="eventsCard"
            :PreviewUpdate="PreviewUpdateLinkedIn"
            :svg="LinkedInTemplate"
            :Posts="Postslinkedin"
          />
        </el-tab-pane>
        <el-tab-pane name="Twitter"
          ><div
            slot="label"
            class="text-center flex items-center cursor-pointer"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/branding/twitter.png"
              alt="image"
              class="w-6 h-6"
            />

            <p class="text-center text-4f4f4f pl-2">Twitter</p>
          </div>
          <TwitterEvents
            @isShowUpdate="ShowEdit"
            @Platformname="Platformname"
            :layout="layoutPriview"
            :events="eventsCard"
            :PreviewUpdate="PreviewUpdateTwitter"
            :svg="TwitterTemplate"
            :Posts="PostsTwitter"
          />
        </el-tab-pane>

        <el-tab-pane name="Stories"
          ><div
            slot="label"
            class="text-center flex items-center cursor-pointer"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Admin/extensions/story.png"
              alt="image"
              class="w-6 h-6"
            />

            <p class="text-center text-4f4f4f pl-2">Stories</p>
          </div>
          <StoriesEvents
            @isShowUpdate="ShowEdit"
            @Platformname="Platformname"
            :layout="layoutPriview"
            :PreviewUpdate="PreviewUpdateStories"
            :svg="StoriesTemplate"
            :events="eventsCard"
            :Posts="PostsStories"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { BrandingGallerylogic } from "./BrandingGallerylogic";
import EditCompVue from "./EditComp.vue";

export default {
  components: {
    EditComp: EditCompVue,
  },
  name: "BrandGuidelines",
  mixins: [BrandingGallerylogic],
};
</script>

<style>
.bradgall .el-dialog__body {
  padding: 25px 25px 0px 25px;
}
</style>
